import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('taskSpots', taskSpots);

function taskSpots() {
  return function taskSpotsFilter(taskRef) {
    if (!taskRef) return;
    let spotsSum = 0;
    _.forEach(taskRef.packageList, (p) => {

      if (p && p.items && p.items.length) {
        const partialSpotsSum = p.items.reduce((acc, item) => {
          if (item.requiredSpots) {
            acc += item.requiredSpots;
          }
          return acc;
        }, 0);
        spotsSum += partialSpotsSum;
      }
    })
    return spotsSum;
  }
}
